import React from "react";
import "./Error404.css";
import { IMAGES } from "../../config/supabaseImages";
import Footer from "../Footer/Footer";

export default function Error404() {
  const logo =
    IMAGES?.logos?.logoBlanco ||
    IMAGES?.logos?.logoNegroSintesis ||
    IMAGES?.logos?.logoNegro ||
    "";

  const PLACEHOLDER_LOGO =
    'data:image/svg+xml;utf8,' +
    encodeURIComponent(
      `<svg xmlns="http://www.w3.org/2000/svg" width="400" height="120" viewBox="0 0 400 120"><rect width="100%" height="100%" fill="#111"/><text x="50%" y="50%" fill="#fff" font-family="Arial, sans-serif" font-size="20" dominant-baseline="middle" text-anchor="middle">Sole Costilla</text></svg>`
    );

  const handleLogoError = (e) => {
    e.currentTarget.onerror = null;
    e.currentTarget.src = PLACEHOLDER_LOGO;
    e.currentTarget.alt = "Logo (fallback)";
  };

  return (
    <>
      <main className="err404-root" role="main">
      <div className="err404-card">
        <img
          className="err404-logo"
          src={logo || PLACEHOLDER_LOGO}
          alt="Sole Costilla logo"
          onError={handleLogoError}
          loading="lazy"
          width="180"
          height="60"
        />

        <h1 className="err404-code">404</h1>
        <h2 className="err404-title">Página no encontrada</h2>
        <p className="err404-desc">
          Lo sentimos — la página que buscas no existe o fue movida. Si crees que esto es un error,
          escribinos y lo solucionamos.
        </p>

        <div className="err404-cta">
          <a className="btn-primary" href="/">Volver al inicio</a>
        </div>

        <div className="err404-help">
          <strong>Sugerencia:</strong> revisá la URL o volvé a la página principal. Si querés, enviános un
          mensaje a <a href="mailto:s1c.softwares@gmail.com" className="err404-help-link">s1c.softwares@gmail.com</a>.
        </div>
      </div>
    </main>
      <Footer />
    </>
  );
}
